export const GROWTH_POPUP = {
  YES: '1', // 公司号码包试验返回'1',进行弹窗
  NO: '0', //  公司号码包试验返回'0',不进行弹窗
};
